import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Header } from './Header';
import { Footer } from './Footer';
import { Sidebar } from './Sidebar';
import { useCurrentUserQuery } from '@/services/usersService';

export function MainLayout() {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const currentUserQuery = useCurrentUserQuery();
  const isAdmin = currentUserQuery.data?.roleId === 1;

  useEffect(() => () => {
    toast.remove();
  }, [location.pathname]);

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <Header sidebarOpen={sidebarOpen} onSidebarToggle={() => setSidebarOpen((v) => !v)} />
      <Sidebar
        open={sidebarOpen}
        isAdmin={isAdmin}
        onClose={() => setSidebarOpen(false)}
      />
      <main className="flex-1 overflow-y-auto bg-white p-4 pb-[43px] sm:p-6 sm:pb-[43px] lg:px-14">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
